module.exports = __webpack_public_path__ + "static/media/single2.ea4d1185.svg";